<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    subtitle: {
        type: String,
        required: true,
    },
    subtitlePosition: {
        type: String,
        default: "top",
        validator(value) {
            return ["top", "bottom"].includes(value as string);
        },
    },
    headingType: {
        type: String,
        default: "h1",
        validator(value) {
            return ["h1", "h2", "h3", "h4", "h5"].includes(value as string);
        },
    },
    topMargin: {
        type: Number,
        default: 5,
    },
});

// Tailwind generates utilities by scanning source text, so a class name built at
// runtime ("mt-" + n) would never be emitted. The full strings must appear here.
// Values mirror the previous PrimeFlex spacing steps (3 = 1rem, 5 = 2rem, ...).
const TOP_MARGIN_CLASS: Record<number, string> = {
    0: "mt-0",
    1: "mt-1",
    2: "mt-2",
    3: "mt-4",
    4: "mt-6",
    5: "mt-8",
    6: "mt-12",
    7: "mt-16",
    8: "mt-20",
};

const topMarginClass = computed(() => TOP_MARGIN_CLASS[props.topMargin] ?? "mt-8");
</script>

<template>
    <span v-if="subtitlePosition == 'top'" class="subtitle mb-0 text-brand" :class="topMarginClass">{{
        subtitle
    }}</span>
    <component
        :is="headingType"
        class="m-0 text-secondary title"
        :class="subtitlePosition == 'top' ? 'mb-4' : topMarginClass"
        >{{ title }}</component
    >
    <span v-if="subtitlePosition == 'bottom'" class="subtitle mb-4 mt-0 text-brand">{{ subtitle }}</span>
</template>
